import { render, staticRenderFns } from "./datasource-electronic-storage-form.vue?vue&type=template&id=10da5250"
import script from "./datasource-electronic-storage-form.vue?vue&type=script&lang=js"
export * from "./datasource-electronic-storage-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports